<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">

      <b-card class="mb-0 text-center">

        <b-link class="brand-logo">
          <vuexy-logo />
        </b-link>

        <b-card-title class="mb-1">
<!--          به زیره خوش آمدید! 👋-->
           {{ this.$t('login.title')}}
        </b-card-title>
        <b-card-text
          style="font-size: 0.9rem;"
          class="mb-2"
        >
<!--          شماره موبایل خود را جهت دریافت کد و آغاز یک روز کاری فوق العاده وارد نمایید-->
            {{ this.$t('login.subtitle')}}

        </b-card-text>
          <b-form-radio-group
              v-if="step === 'code'"
                  id="login-radio-group"
                  v-model="VerifyType"
                  name="login"
                  :options="[{text:$t('login.mobile'),value: 0},{text:$t('login.email'),value: 1}]"
          />
        <b-form
          v-if="step === 'code'"
          class="auth-login-form mt-2"
          @submit.prevent
        >
            <b-form-input
              id="mobile"
              v-model="mobile"
              autofocus
              autocomplete="off"
              @keyup.enter="sendCode"
            />

          <b-button
            variant="primary"
            block
            class="mb-1 mt-2"
            @click="sendCode"
          >
<!--            دریافت کد-->
             {{$t('btnGetCode')}}
          </b-button>

        </b-form>
        <b-form v-else @submit.prevent>
          <b-form-group>
            <div class="d-flex justify-content-between mt-2">
              <label for="code">
                {{ this.$t('login.btn')}}
                <!--    کد دریافتی-->
              </label>
            </div>
            <b-input-group
                class="input-group-merge"
            >
              <b-form-input
                  id="code"
                  v-model="code"
                  class="form-control-merge"
                  autocomplete="off"
                  @keyup.enter="login"
              />
              <b-input-group-append is-text>
                <span
                    v-if="timerCounter !== 0"
                    class="text-primary"
                >{{ timerCounter }}</span>
                <span
                    v-else
                >
                  <feather-icon
                      class="cursor-pointer"
                      icon="RepeatIcon"
                      @click="sendCode"
                  />
                </span>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
          <b-button
              variant="primary"
              block
              class="mb-1 mt-2"
              @click="login"
          >
            {{$t('btnEnter')}}
          </b-button>
        </b-form>

      </b-card>
    </div>
  </div>
</template>

<script>
import {
  BButton, BForm, BFormInput, BFormGroup, BCard, BLink, BCardTitle, BCardText, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import useJwt from '@/auth/jwt/useJwt'

export default {
  components: {
    // BSV
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BCardTitle,
    BLink,
    VuexyLogo,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
  },
  data() {
    return {
      mobile: null,
      code: null,
      showInputCode: false,
      timerCounter: 120,
      activeTimerSendAgainCode: false,
      VerifyType:0,
      step: 'code'
    }
  },
  watch: {
    activeTimerSendAgainCode(val) {
      if (val === true) {
        this.timerID = setInterval(() => {
          this.timerCounter -= 1
        }, 1000)
      }
    },
    timerCounter(val) {
      if (val === 0) {
        clearInterval(this.timerID)
        this.activeTimerSendAgainCode = false
      }
    },
  },
  created() {
    this.$i18n.locale = 'en'
  },
  methods: {
    login() {
      useJwt.login(
        {
          Username: this.mobile,
          VerifyType: this.VerifyType,
          Code: this.code,
        },
      ).then(res => {
        useJwt.setToken(res.data.Key)
        this.getUserPermission()
      }).finally(() => {
        this.loading = false
      })
    },
    getUserPermission() {
      // const userData = response.data.UserInfo

      this.$http.post(
        this.$api.userpermission.getuserpermission,
        {},
      ).then(res => {
        const permissions = [{
          action: 'show',
          subject: 'Auth',
        }]

        res.data.UserPermission.forEach(per => {
          permissions.push({
            action: 'show',
            subject: per.Key,
          })
        })

        localStorage.setItem('userData', JSON.stringify({
          ability: permissions, UserRoleTitle: res.data.UserRoleTitle, Name: res.data.Name, Family: res.data.Family, Image: res.data.Image, ID: res.data.Id,
        }))

        this.$ability.update(permissions)
        this.$router.push({ name: 'home' })
      })
    },
    sendCode() {
      this.timerCounter = 120
      this.$http.post(this.$api.authentication.Login, {
        Username: this.mobile,
        VerifyType: 0,
      })
        .then(() => {
          this.showInputCode = true
          this.timerCounter = 120
        }).finally(() => {
        this.activeTimerSendAgainCode = true
        this.step = 'login'
          this.loading = false
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
